export default "__VITE_ASSET__fdfa0337__"